module.exports = __webpack_public_path__ + "static/media/9.67d6212c.jpg";